import OurStoryComponent from '../OurStory/index.vue';

export default {
  name: 'Header',
  data() {
    return { OurStoryComponent };
  },
};
